import { Box, Flex, Icon, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";

import { useCart } from "../../../hooks/cart";

type SortData = {
	por: string;
	cres: boolean;
}
type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
}
type IndicadorData = {
	id: string;
	nome: string;
	cid: string
	doc: string;
	phone: string;
	comissao: number;
}
interface DataTableTableParams {
	clientes: IndicadorData[];
	pesqClientes: IndicadorData[];
	sort: SortData;
	setSort: (sort: SortData) => void;
	controls: ControlsData;
	handleUpdateList: (page: number, perPage: number, clients: IndicadorData[]) => void;
	onRequestClose: (close: boolean) => void;
}

const DataTableTable: React.FC<DataTableTableParams> = ({
	clientes,
	pesqClientes,
	sort,
	setSort,
	controls,
	handleUpdateList,
	onRequestClose
}) => {
	const { addCartIndicador } = useCart();

	function handleSort(prop: string) {
		let mapped: IndicadorData[] = [];

		const auxCres = !sort.cres;

		if (sort.por === prop) {
			if (auxCres) {
				mapped = pesqClientes.sort((a, b) => {
					return (
						+(Object(a)[prop] > Object(b)[prop]) ||
						+(Object(a)[prop] === Object(b)[prop]) - 1
					);
				});
			} else {
				mapped = pesqClientes.sort((a, b) => {
					return (
						+(Object(a)[prop] < Object(b)[prop]) ||
						+(Object(a)[prop] === Object(b)[prop]) - 1
					);
				});
			}
			setSort({ ...sort, cres: auxCres });
		} else {
			mapped = pesqClientes.sort((a, b) => {
				return (
					+(Object(a)[prop] > Object(b)[prop]) ||
					+(Object(a)[prop] === Object(b)[prop]) - 1
				);
			});
			setSort({ por: prop, cres: true });
		}

		// setSort({ por: prop, cres: !sort.cres });

		handleUpdateList(1, controls.perPage, mapped);
	};

	return (
		<Table colorScheme="blackAlpha">
			<Thead>
				<Tr>
					<Th cursor="pointer" onClick={() => handleSort('nome')}>
						<Flex align="center">
							Nome
							{sort.por === 'nome' && sort.cres
								? <Icon as={MdArrowDropUp} fontSize="20" />
								: sort.por === 'nome' && !sort.cres && (<Icon as={MdArrowDropDown} fontSize="20" />)
							}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('doc')}>
						<Flex align="center">
							Documento
							{sort.por === 'doc' && sort.cres
								? <Icon as={MdArrowDropUp} fontSize="20" />
								: sort.por === 'doc' && !sort.cres && (<Icon as={MdArrowDropDown} fontSize="20" />)
							}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('cid')}>
						<Flex align="center">
							Cidade
							{sort.por === 'cid' && sort.cres
							? <Icon as={MdArrowDropUp} fontSize="20" />
							: sort.por === 'cid' && !sort.cres && (<Icon as={MdArrowDropDown} fontSize="20" />)
						}
						</Flex>
					</Th>
				</Tr>
			</Thead>

			<Tbody>
				{clientes.map((cliente, indice) => {
					return (
						<Tr key={indice} onClick={() => {
								addCartIndicador(cliente);
								onRequestClose(false);
							}}
						>
							<Td
								py="2"
								cursor="pointer"
								onClick={() => {}}
							>
								<Box>
									<Text color="blue.100" fontWeight="bold">{cliente.nome}</Text>
									<Text fontSize="sm" color="gray.500">{cliente.phone}</Text>
								</Box>
							</Td>
							<Td py="2" color="gray.500">{cliente.doc}</Td>
							<Td py="2" color="gray.500">{cliente.cid}</Td>
						</Tr>
					)
				})}
			</Tbody>
		</Table>
	)
}

export default DataTableTable;
